exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".McHome {\n  height: 100vh;\n  color: #fff; }\n  .McHome h1 {\n    margin-bottom: 75px; }\n  .McHome form {\n    margin-top: 100px; }\n    .McHome form .form-group {\n      margin-right: 20px; }\n      .McHome form .form-group input {\n        max-width: 200px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/MC/Home/McHome.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/MC/Home/McHome.css
// module chunks = 0